import { render } from "./profile.vue?vue&type=template&id=1d3dfe7e&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"

import "./profile.vue?vue&type=style&index=0&id=1d3dfe7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d3dfe7e"

export default script